import React, { memo } from "react"
import { Link } from "gatsby"
import "../styles/relatedSolutions.scss"

/**
 * Additive "Related solutions" block appended at the bottom of existing,
 * already-indexed pages (spec 7.1). It renders after all existing content and
 * changes nothing above it — no heading, title, meta or layout of the host
 * page is touched.
 *
 * Anchor text is passed in per host page rather than generated, because the
 * same destination must not carry an identical anchor everywhere (spec 7.4).
 */
const RelatedSolutions = ({ heading = "Related solutions", links }) => {
  if (!links || !links.length) return null

  return (
    <section className="rs-block" aria-label={heading}>
      <div className="rs-block__inner">
        <h2 className="rs-block__heading">{heading}</h2>
        <ul className="rs-block__list">
          {links.map(l => (
            <li key={l.to} className="rs-block__item">
              <Link to={l.to} className="rs-block__link">
                {l.label}
              </Link>
              {l.note && <span className="rs-block__note">{l.note}</span>}
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}

export default memo(RelatedSolutions)
